import axios from 'axios';
import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import AdminLayout from '../Componets/AdminLayout'; // Ensure the path is correct
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as XLSX from 'xlsx';
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip';
import { TbTrophyOff, TbTrophy } from 'react-icons/tb';

export default function ListMarks() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const location = useLocation();
  const { subjectId, examId, subjectName, ExamName } = location.state || {};
  const navigate = useNavigate();
  const [records, setRecords] = useState([]); // State for storing fetched faculty records
  const [currentPage, setCurrentPage] = useState(1); // Current page number
  const [perPage, setPerPage] = useState(10); // Number of items per page
  const [searchTerm, setSearchTerm] = useState(''); // State for search term
  const [marksData, setMarksData] = useState({}); // Store marks for each row
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState('Click To Upload File For Marks');
  const [prevMarksData, setPrevMarksData] = useState({});

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role !== 'ADMIN') {
      navigate('/');
    }
  }, [navigate]);

  useEffect(() => {
    if (examId && subjectId) {
      fetchRecords();
    }
  }, [examId, subjectId, apiUrl, navigate]);
  // get table data api
  const fetchRecords = async () => {
    const token = localStorage.getItem('token'); // Retrieve token from localStorage
    if (!token) {
      navigate('/');
      return;
    }
    try {
      const response = await axios.get(
        `${apiUrl}/api/omrmarks/list/${examId}/${subjectId}?allocationType=NORMAL`,
        {
          headers: {
            Authorization: token, // Set Authorization header with token
          },
        }
      );
      setRecords(response.data.omrmark);
    } catch (error) {
      console.error('Error fetching records:', error);
      if (error.response?.status === 401) {
        navigate('/');
      }
    }
  };

  const handleMarksChange = (row, value) => {
    setMarksData((prev) => ({
      ...prev,
      [row.barcodeNo]: value, // Use barcode as a unique key
    }));
  };
  // add marks api to add marks of omr
  const handleMarksBlur = async (row) => {
    const marks = marksData[row.barcodeNo]?.trim(); // Get the updated marks value

    // Check if marks have changed, if not, do not make the API call
    if (marks === prevMarksData[row.barcodeNo]) return;

    if (!marks) return; // Prevent empty submissions

    const token = localStorage.getItem('token');
    if (!token) {
      toast.error('Unauthorized access!');
      navigate('/');
      return;
    }

    const data = {
      id: row.id,
      marks: +marks, // Convert to integer
      rollNumber: row.rollNumber,
      examId: +row.examId,
      subjectId: +row.subjectId,
    };

    try {
      const response = await axios.post(
        `${apiUrl}/api/omrmarks?allocationType=NORMAL`,
        data,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        }
      );
      toast.success(response.data.message);
      fetchRecords(); // Refresh the table after update
      setPrevMarksData((prev) => ({
        ...prev,
        [row.barcodeNo]: marks,
      }));
    } catch (error) {
      console.error('Error updating marks:', error);
      // Retain the previous value instead of setting it to null
      setMarksData((prev) => ({
        ...prev,
        [row.barcodeNo]: prev[row.barcodeNo] ?? row.marks ?? '',
      }));
      toast.error(error.response?.data?.message);
    }
  };

  // this api are marks delete api
  const handleDeleteMarks = async (row) => {
    if (!window.confirm('Are you sure you want to delete this mark?')) return;

    try {
      const response = await axios.delete(`${apiUrl}/api/omrmarks/${row.id}`, {
        headers: {
          Authorization: localStorage.getItem('token'),
        },
      });

      toast.success(response.data.message);

      // Clear the marksData state for the deleted row
      setMarksData((prev) => {
        const updatedMarks = { ...prev };
        delete updatedMarks[row.barcodeNo]; // Remove the entrys
        return updatedMarks;
      });

      fetchRecords(); // Refresh the table
    } catch (error) {
      console.error('Error deleting marks:', error);
      toast.error('Failed to delete marks.');
    }
  };

  // this key Down tio teb to add marks
  const handleKeyDown = (e) => {
    if (e.key === 'Tab') {
      e.preventDefault(); // Prevent default tab behavior
      const inputs = document.querySelectorAll('input'); // Get all input fields
      const currentIndex = [...inputs].indexOf(e.target);

      if (e.shiftKey) {
        // Shift + Tab: Move focus to the previous input
        if (currentIndex > 0) {
          inputs[currentIndex - 1].focus();
        }
      } else {
        // Tab: Move focus to the next input
        if (currentIndex < inputs.length - 1) {
          inputs[currentIndex + 1].focus();
        }
      }
    }
  };

  const columns = [
    {
      name: 'No',
      selector: (row, index) => (currentPage - 1) * perPage + index + 1,
      width: '50px',
      center: 'true',
    },

    {
      name: 'Roll No',
      selector: (row) => row.rollNumber,
      sortable: true,
      width: '150px',
      center: 'true',
    },
    {
      name: 'Name',
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: 'Barcode',
      selector: (row) => row.barcodeNo,
      sortable: true,
      width: '150px',
      center: 'true',
    },

    {
      name: 'Total OMR Marks',
      selector: (row) => row.omrTotalMark,
      sortable: true,
      width: '150px',
      center: 'true',
    },
    {
      name: 'OMR Marks',
      width: '130px',
      cell: (row, rowIndex, column, id) => (
        <input
          type="text"
          value={marksData[row.barcodeNo] ?? row.marks ?? ''}
          className="form-control form-control-sm"
          placeholder="Enter Marks"
          onChange={(e) => handleMarksChange(row, e.target.value)}
          onBlur={() => handleMarksBlur(row)}
          onKeyDown={(e) => handleKeyDown(e, rowIndex)}
          data-row-index={rowIndex} // Store row index for reference
        />
      ),
    },
    {
      name: 'Actions',
      width: '90px',
      center: 'true',
      cell: (row) => (
        <button
          className="btn btn-outline-danger btn-sm"
          disabled={row.id === null}
          onClick={() => handleDeleteMarks(row)}
          data-tooltip-id="my-tooltip"
          data-tooltip-content="Delete Student OMR Marks"
        >
          <i className="bi bi-trash3-fill"></i>
        </button>
      ),
    },
  ];
  const exportToExcel = (isManual) => {
    if (records.length === 0) {
      toast.error('No data available to export.');
      return;
    }

    // Filter records based on whether marks are null or not
    const filteredRecords = isManual
      ? records?.filter((row) => row?.marks !== null) // Students with marks
      : records?.filter((row) => row?.marks === null); // Students without marks

    if (filteredRecords.length === 0) {
      toast.error(
        `No ${isManual ? 'students with marks' : 'students without marks'} available to export.`
      );
      return;
    }

    const data = filteredRecords.map((row) => ({
      rollNumber: row.rollNumber,
      Marks: row.marks ?? '',
    }));

    const ws = XLSX.utils.json_to_sheet(data);

    // Set column width
    ws['!cols'] = [
      { wpx: 100 }, // Roll Number
      { wpx: 200 }, // Name
      { wpx: 150 }, // Barcode
      { wpx: 80 }, // Marks
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, `Marks List`);

    // File name based on type of data exported
    const fileType = isManual ? 'With_Marks' : 'Without_Marks';
    XLSX.writeFile(wb, `Marks_List_${fileType}_${subjectName}.xlsx`);
  };

  const handleFileChange = (event) => {
    if (event.target.files.length > 0) {
      setFile(event.target.files[0]);
      setFileName(event.target.files[0].name);
    } else {
      setFileName('Click To Upload File For Marks');
    }

    // Reset input value to allow selecting the same file again
    event.target.value = '';
  };

  const handleUpload = async () => {
    if (!file) {
      toast.error('Please select a file before uploading.');
      return;
    }
    const token = localStorage.getItem('token'); // Retrieve token from localStorage
    const formData = new FormData();
    formData.append('examId', +examId);
    formData.append('subjectId', +subjectId);
    formData.append('omrMarks', file);
    formData.append('allocationType', 'NORMAL');
    try {
      const response = await axios.post(
        `${apiUrl}/api/omrmarks/upload`,
        formData,
        {
          headers: {
            Authorization: token, // Replace with actual token
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      toast.success(response.data.message);
      fetchRecords();
      setFile(null);
      setFileName('Click To Upload File For Marks');
      closemodel();
    } catch (error) {
      console.error('Error:', error);
      toast.error(error.response?.data?.message);
      fetchRecords();
      setFile(null);
      closemodel();
    }
  };
  const closemodel = () => {
    const closeButton = document.querySelector('#exampleModal .btn-close');
    if (closeButton) {
      closeButton.click();
    }
  };

  return (
    <main id="main" className="main">
      <AdminLayout ac13="active">
        <div className="pagetitle">
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/AdminHome">Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <span className="cursor-pointer" onClick={() => navigate(-2)}>
                  Exams for OMR Result
                </span>
              </li>
              <li className="breadcrumb-item">
                <span className="cursor-pointer" onClick={() => navigate(-1)}>
                  Subject list
                </span>
              </li>
              <li className="breadcrumb-item active">
                OMR Marks list ({subjectName})
              </li>
            </ol>
          </nav>
        </div>
        <hr className="mb-0" />

        <div className="row">
          <div className="container">
            <div className="datatable-top">
              <div className="datatable-search">
                <input
                  className="form-control"
                  type="search"
                  placeholder="Search"
                  title="Search within table"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div>
                <button
                  type="button"
                  className="btn btn-primary mx-2"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content="Upload Marks"
                >
                  <i className="bi bi-upload"></i>
                </button>
              </div>
            </div>

            <div className="table-responsive">
              <DataTable
                columns={columns}
                data={records?.filter((record) =>
                  record?.name.toLowerCase().includes(searchTerm.toLowerCase())
                )}
                pagination
                paginationTotalRows={records.length}
                paginationRowsPerPageOptions={
                  records.length > 40
                    ? [10, 15, 20, 40, records.length]
                    : [10, 15, 20, 40]
                }
                onChangePage={setCurrentPage}
                className="custom-table"
              />
              <ToastContainer position="top-center" style={{ width: 'auto' }} />
            </div>
          </div>
        </div>

        <Tooltip id="my-tooltip" />
      </AdminLayout>

      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Modal title
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="col text-center">
                <label className="mb-2">Upload Student Details </label>
                <div
                  className="upload-area"
                  onClick={() =>
                    document.getElementById('formFile-question').click()
                  }
                  style={{ cursor: 'pointer', width: '465px' }}
                >
                  <div className="icon">
                    <img
                      src="https://cdn-icons-png.freepik.com/512/16001/16001736.png"
                      alt="Upload"
                    />
                  </div>
                  <p className="text">{fileName}</p>
                  <input
                    className="form-control"
                    name="questionpaper"
                    type="file"
                    id="formFile-question"
                    onChange={handleFileChange}
                    style={{ display: 'none' }}
                    accept=".xlsx"
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-success  mx-1"
                onClick={() => exportToExcel(true)}
              >
                <TbTrophy className="fs-5" />
              </button>
              <button
                className="btn btn-primary"
                onClick={() => exportToExcel(false)}
              >
                <TbTrophyOff className="fs-5" />
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleUpload}
              >
                Uplode
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
